import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root'
})
export class DataSaverService {
  private _platform = inject(PlatformService);


  private _dataStorage: Map<string, Array<string>>;

  constructor() {
    this._load();
    this._tabHandle();
  }

  /**
   * Push new value in the list by key
   *
   * @param key
   * @param value
   * @param valPrefix
   */
  push(key: string, value: string) {
    if (this._dataStorage.has(key)) {
      const data = this._dataStorage.get(key);

      if (!data.includes(value)) {
        data.push(value);
      }
    } else {
      this._dataStorage.set(key, [value]);
    }
  }

  /**
   * Extract values list by key
   *
   * @param key
   */
  extract(key: string): Array<string> {
    return this._dataStorage.get(key) || [];
  }

  /**
   * Remove values list by key
   *
   * @param key
   */
  remove(key: string) {
    if (this._dataStorage.has(key)) {
      this._dataStorage.delete(key);

      if (this._platform.isBrowser) {
        window.localStorage.removeItem('saved-data');
      }
    }
  }

  /**
   * Load date from local storage
   *
   * @private
   */
  private _load() {
    if (this._platform.isBrowser && !environment.production) {
      const data = window.localStorage.getItem('saved-data');

      if (data) {
        this._dataStorage = this._objectToMap(JSON.parse(data));
      } else {
        this._dataStorage = new Map<string, Array<string>>();
      }

    } else {
      this._dataStorage = new Map<string, Array<string>>();
    }
  }

  /**
   * Save data in local storage
   *
   * @private
   */
  private _save() {
    if (this._platform.isBrowser && !environment.production) {
      window.localStorage.setItem('saved-data', JSON.stringify(this._mapToObject(this._dataStorage)));
    }
  }

  /**
   * Handle tab closing
   *
   * @private
   */
  private _tabHandle() {
    if (this._platform.isBrowser && !environment.production) {
      window.onbeforeunload = () => {
        this._save();
      };
    }
  }

  /**
   * Convert map to object
   *
   * @param map
   * @private
   */
  private _mapToObject(map: Map<string, Array<string>>) {
    const o = Object.create(null);

    map.forEach((value, key) => {
      o[key] = value;
    });

    return o;
  }

  /**
   * Convert object to map
   *
   * @param object
   * @private
   */
  private _objectToMap(object) {
    const m = new Map<string, Array<string>>();

    Object.keys(object).forEach(key => {
      m.set(key, object[key]);
    });

    return m;
  }
}
